import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import CurrentSessionInterface from '@api/requests/auth/interfaces/CurrentSessionInterface.interface';
import configRequest from '@api/requests/configRequest';

export interface RefreshTokenData {
	refresh_token?: string;
	branch?: number;
}

export interface RefreshTokenResponse {
	login_basic: {
		tokens: CurrentSessionInterface;
	};
}

const refreshToken = configRequest<RefreshTokenResponse, RefreshTokenData>({
	requestPrefix: 'auth/refreshToken',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.REFRESH_TOKEN(),
		method: HTTP_METHODS_ENUM.POST,
		headers: { branch: data?.branch?.toString() || '' },
		data: { refresh_token: data?.refresh_token, token_generation_mode: 'standard' },
	}),
});

export default refreshToken;
